import React from 'react';
import { Link } from 'react-router-dom';
import {
  List,
  TextField,
  Datagrid,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  ReferenceInput,
  SelectInput,
  FunctionField,
  translate as t,
} from 'admin-on-rest';

import { FlatButton } from 'material-ui';

import EditButton from '../components/button/EditButton';
import { getTranslationByLocale } from '../utils/TranslationUtils';

export const WebsiteList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="name" />
      <TextField source="market" />
      <FunctionField render={(record) => <FlatButton primary containerElement={Link} to={`/web-pages?filter=%7B%22website%22%3A%22${record.id}%22%7D&page=1&perPage=9999`}>Pages</FlatButton>} />
      <EditButton {...props} />
    </Datagrid>
  </List>
));

export const WebsiteEdit = t((props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <ReferenceInput label={props.translate('resources.markets.name', { smart_count: 1 })} source="market" reference="markets" allowEmpty>
        <SelectInput optionText={<Title {...props} />} />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
));

export const WebsiteCreate = t((props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <ReferenceInput label={props.translate('resources.markets.name', { smart_count: 1 })} source="market" reference="markets" allowEmpty>
        <SelectInput optionText={<Title {...props} />} />
      </ReferenceInput>
    </SimpleForm>
  </Create>
));

const Title = t(({ record, locale }) => (getTranslationByLocale(record.title, locale)));
